import { Component, ElementRef, ViewChild } from '@angular/core';
import { WizBasePopUp } from '@wizeoo/akm-component-lib';
import { DataMessage } from '../../../manager/baselines/data.message';


@Component({
  // affichage des informations de chargement
  selector: 'loading-pop',
  templateUrl: './loading.pop.html',
})
export class LoadinPop extends WizBasePopUp {
  
  @ViewChild('scr') private scr: ElementRef;
  
  public message: string = '';

  public onShow(): void {
    let dataMessage: DataMessage = this.datas;
    dataMessage.loadingPop = this; // on s'enregistre dans le dataMessage, pour synchro sans event

    super.onShow();
  }


  public addMessage(mess: string): void {
    if(!!mess) {
      this.message += mess + '</br>';
      this.scrollToElement();
    }
  }

  scrollToElement(): void {
    // console.log(this.scr.nativeElement.scrollTop);
    if (this.scr?.nativeElement) {
      this.scr.nativeElement.scrollTop = this.scr.nativeElement.scrollHeight; 
    }
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }
}
